import React, { useContext, useEffect } from 'react';
import {
  AuthenticationContext,
  useIsLoggedIn,
} from 'components/templates/AuthenticationProvider/AuthenticationProvider';
import LoadingScreen from 'components/atoms/LoadingScreen/LoadingScreen';
import useExternalLink from 'hooks/useExternalLink';

export interface Props {}

const Logout: React.FC<Props> = () => {
  const isLoggedIn = useIsLoggedIn();
  const { logOut } = useContext(AuthenticationContext);
  const onePLink = useExternalLink('home');

  useEffect(() => {
    if (isLoggedIn) {
      logOut('logout');
    }
    window.location.replace(onePLink || 'https://www.lifepointspanel.com');
  }, [isLoggedIn]);

  return <LoadingScreen />;
};
export default Logout;
